<div class="white-box title-box">
  <h4>{{ 'steps.id5.account_to_fund.deposit_box.title' | translate }}</h4>
</div>
<div class="white-box section-details">
  <p class="description">{{ 'steps.id5.account_to_fund.deposit_box.intro' | translate }}</p>
  <div class="bank-details">
    <div class="bank-details-detail">
      <p class="strong">{{ 'steps.id5.account_to_fund.deposit_box.bank' | translate }}</p>
      <p [innerHTML]="'reinvest.bankname-3a' | translate"></p>
    </div>
    <div class="bank-details-detail">
      <p class="strong">{{ 'reinvest.foundation' | translate }}</p>
      <p class="strong" [innerHTML]="'reinvest.bankaddress-3a' | translate"></p>
    </div>
    <div class="bank-details-detail">
      <p class="strong">{{ 'steps.id5.account_to_fund.deposit_box.account' | translate }}</p>
      <p>{{ currentAccount.liberty_account.qr_iban }}</p>
    </div>
    <div class="bank-details-detail">
      <p class="strong">{{ 'steps.id5.account_to_fund.deposit_box.reference' | translate }}</p>
      <p>{{ currentAccount.liberty_account.reference_number }}</p>
    </div>
  </div>
  <app-deposit-delay-info [addMargin]="false"></app-deposit-delay-info>
</div>
